var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-refund-order-list',{ref:"table",staticClass:"pt-refund-order-list__withData",attrs:{"exportLoading":_vm.exportLoading,"pageSize":_vm.pageSize},on:{"exportRefund":_vm.exportRefund}})}
var staticRenderFns = []

export { render, staticRenderFns }